module.exports = __webpack_public_path__ + "img/ghosttown.fbf26645.jpg";